import { RouteConstants } from "src/app/constants/routeConstants";
import { ItemType } from "src/app/models/enums/itemType";

export class ItemTypeMapper {
    public static map(itemTypeId: number): ItemType {
        switch(itemTypeId) {
            case 109: return ItemType.TestCase;
            case 110: return ItemType.TestSuite;
            case 236: return ItemType.TestAnalysis;
            case 382: return ItemType.SpecificationCoverage;
            case 410: return ItemType.TestSpecification;
            default: return undefined;
        }
    }

    public static mapReverse(itemType: ItemType): number {
        switch(itemType) {
            case ItemType.TestCase: return 109;
            case ItemType.TestSuite: return 110;
            case ItemType.TestAnalysis: return 236;
            case ItemType.SpecificationCoverage: return 382;
            case ItemType.TestSpecification: return 410;
            default: return undefined;
        }
    }

    public static mapToRoute(itemType: ItemType): string {
      switch (itemType) {
        case ItemType.TestCase:
          return RouteConstants.TEST_CASES;
        case ItemType.TestSuite:
          return RouteConstants.TEST_SUITES;
        case ItemType.TestAnalysis:
          return RouteConstants.TEST_ANALYSIS;
        case ItemType.SpecificationCoverage:
          return RouteConstants.SPECIFICATION_COVERAGE;
        case ItemType.SoftwareVersionCoverage:
          return RouteConstants.SOFTWARE_VERSION_COVERAGE;
        case ItemType.TestSpecification:
          return RouteConstants.TEST_SPECIFICATIONS;
        default:
          return RouteConstants.BASE;
      }
    }
}
